// extracted by mini-css-extract-plugin
export default {"root":"ExpertBadge_root__WX4N9","content":"ExpertBadge_content__GBOuI"};